export const DeliveryStatus = Object.freeze({
  Pending: 'PENDING',
  Complete: 'COMPLETE',
  Cancelled: 'CANCELLED',
})
